/* This file is autogenerated, see readme.md for instructions */
import FormulaSvgIcon from '@bloomreach/banana-theme/icons/formula.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FormulaIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FormulaSvgIcon />
    </Icon>
  );
});

FormulaIcon.displayName = 'FormulaIcon';

export default FormulaIcon;
